import type { LicenseEntitlementKey } from '#layers/license/types/license';

/** i18n key prefix for entitlement titles, shared by the display config and gate surfaces. */
const TITLE_PREFIX = 'organization.dashboard.settings.license.entitlements';

export function entitlementTitleKey(key: LicenseEntitlementKey): string {
	return `${TITLE_PREFIX}.${key}`;
}
